import {alias, createModelSchema, custom, deserialize, list, raw, serialize, SKIP} from "serializr";
import {ExplainerPageImageModel} from "@/modules/muiutils/models/explainers/ExplainerPageImageModel";
import {Cloneable} from "@/common/Cloneable";

export class ExplainerPageModel extends Cloneable {

    constructor(images) {
        super();
        this._images = images;
    }

    get images() {
        return this._images;
    }
    set images(value) {
        this._images = value;
    }

    copy() {
        return super.copy();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ExplainerPageModel());
        } else if (target instanceof ExplainerPageModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(ExplainerPageModel, v) : SKIP;
        }, (v) => {
            return deserialize(ExplainerPageModel, v);
        });
    }

    empty() {
        return this.images.length === 0;
    }
}

createModelSchema(ExplainerPageModel, {
    _images: alias("images", list(ExplainerPageImageModel.schema())),
});